import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import {spacing} from 'material-ui/styles';
import {Link} from 'react-router'; 
import Avatar from 'material-ui/Avatar';
import InputMask from 'react-input-mask';

import urlBase from '../../url-base';

import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import readXlsxFile from 'read-excel-file';
import { Styles, menuStyles } from '../../styles/theme';
import Divider from '@material-ui/core/Divider';
import {
  Button,
} from 'reactstrap';
/* Configuração de perfil*/
var servidor = "servidor";
const menuConfig = [
  {
    title: "Painel de Gestão Comercial",
    icon: "fas fa-home",
    //link: urlBase.client + 'panel/',
    link: '/panel/',
    roles: ['BROKER', 'SALESMAN', 'BACKOFFICE', 'REGISTER', 'AFTER SALES', 'PJCADASTRO', 'SUPERVISOR'] // Todos exceto SUPERVISOR
  },
  {
    title: "Listagem de Empresas",
    icon: "fas fa-building",
    link: '/panel/companylist',
    roles: ['PJCADASTRO'] // Todos exceto SUPERVISOR
  },
  {
    title: "Interessados",
    icon: "far fas fa-users",
    link: '/panel/#',
    roles: ['']
  },
  {
    title: "Planos",
    icon: "fas fa-heartbeat",
    link: '/panel/planlist',
    roles: ['ADMIN']
  },
  {
    title: "Parceiros",
    icon: "fas fa-user-friends",
    roles: ['ADMIN','SUPERVISOR'],
    subItems: [
      { title: "Corretoras", link: "/panel/brokers" },
      { title: "Vendedores", link: "/panel/salesmans" }
    ]
  },  
  {
    title: "Configuração",
    icon: "fas fa-cog",
    roles: ['ADMIN'],
    subItems: [
      { title: "Colaboradores", link: "/panel/contributors" },
      { title: "Pendências", link: "/panel/pendencies" },
      { title: "Cancelamentos", link: "/panel/cancellations" }
    ]
  },  
  {
    // fas fa-user-plus (O mais comum): Ideal se o cadastro for de pessoas/usuários.
    // fas fa-address-card: Ótimo para cadastros mais formais ou fichas cadastrais.
    // fas fa-file-medical ou fas fa-clipboard-list    
    title: "Cadastro",
    icon: "fas fa-address-card fa-lg",

    roles: ['SALESMAN', 'BACKOFFICE', 'PJCADASTRO'],
    subItems: [
      { title: "Plano Individual/Familar", 
        link: "/panel/salesregistration",
        roles: ['SALESMAN'] 
      },
      /*
        - 69a6e247ac05a458990deabb - 11532 - DANIEL MUNIZ SANTOS
        - 60db2529723a84336c5db4f0 - 11130 - JÉSSICA KETHLEEN PEREIRA DA SILVA II
        - 698b5b076dad6c575e370871 - CAMILLA BEATRIZ PINHEIRO CAVALCANTE SILVA
        - 66b5f9abe7c20a534766e989 - 11131 - JULIANA FERREIRA DE ARAUJO
        - 6a71cc77bc137f2ebf7edcf9 - 11645 - JOAQUIM DANIEL DE AZEVEDO ROMA
        - 5b72d2bc1195442302cd6c45 - 8864 - DENTAL ADESÕES ON LINE
        - 6aa3fcbf81fb5e7a748e2445 - 11698 - JESSICA DOS SANTOS BARBOSA
        - 6ab57e38d18cd5516e84d60c - 11741 - RONIVALDO VIEIRA DE SOUZA

      */
      { title: "Plano Servidor", 
        link: `/panel/salesregistrationServidor/${servidor}`,
        allowedUsers: ['6ab57e38d18cd5516e84d60c','6aa3fcbf81fb5e7a748e2445', '69a6e247ac05a458990deabb', '60db2529723a84336c5db4f0', '698b5b076dad6c575e370871', '66b5f9abe7c20a534766e989', '6a71cc77bc137f2ebf7edcf9', '5b72d2bc1195442302cd6c45'],    

        roles: ['SALESMAN', 'REGISTER'] 
      },      
      { title: "Empresarial", 
        link: "/panel/registercompany",
        roles: ['PJCADASTRO', 'SALESMAN'] 
      },
      { title: "Cadastro de Associados - (Novo)", 
        link: "/panel/inclusaoassociado",
        roles: ['PJCADASTRO'] 
      }
     
    ]
  }, 
    {
    title: "Acompanhamento de Vendas",
    icon: "fa fa-eye",
    roles: ['PJCADASTRO', 'SALESMAN', 'ADMIN'], // O PJCADASTRO tem que estar aqui
    link: "/panel/vendas-por-vendedor"
  }, 
  {
    title: "Listagem de Propostas",
    icon: "fas fa-list-ul",
    link: '/panel/proposalsall',
    roles: ['ADMIN']
  },    
  // Temporário
  {
    title: "Inclusão de Associado - Antigo",
    icon: "fas fa-address-card fa-lg",
    roles: ['PJCADASTRO'], // O PJCADASTRO tem que estar aqui
    action: "openCadastroAssociado"
  }, 
  // Fim temporário
  //roles: ['ADMIN', 'SALESMAN']
  {
    title: "Link de Vendas Online",
    icon: "fas fa-link fa-2x",
    roles: ['SALESMAN'], 
    link: '/panel/linksite'
  },  
  {
    title: "Enviar Whatsapp",
    icon: "fab fa-whatsapp",
    roles: ['ADMIN'], // O PJCADASTRO tem que estar aqui
    // desenvolvimento - Jessica - debora - Cristina
    allowedUsers: ['5b72d2bc1195442302cd6c45', '60db2529723a84336c5db4f0', '5dd55301ee0313765bd2bc81', '6130e3def501252ea56929e3'],    
    action: "openEnviarMensagem"
  },
  {
    title: "Averbação de Propostas",
    icon: "fas fa-key",
     link: '/panel/financeiro',
    roles: ['FINANCEIRO']    
  },
  {
    title: "Alterar Senha",
    icon: "fas fa-key",
    action: "openUpdatePassword",
    roles: ['ADMIN', 'BROKER', 'SALESMAN', 'BACKOFFICE', 'REGISTER', 'AFTER SALES', 'PJCADASTRO', 'SUPERVISOR', 'FINANCEIRO']    
  },
  {
    title: "Resetar Senha",
    icon: "fa fa-undo",
    action: "resetPassword",
    roles: ['BROKER', 'SALESMAN', 'SUPERVISOR', 'FINANCEIRO']    
  }     
  // Adicione os outros itens seguindo este padrão...
];
const MenuTheme = {
  itemHover: '#a8243e',    // Fundo Vermelho no Hover
  itemTextHover: '#ffffff', // Texto Branco no Hover
  iconColor: '#a8243e',    // Ícones acompanham o texto

  background: '#e5e8f0',      // Fundo escuro moderno (grafite)
  itemText: '#a8243e',        // Texto branco
  iconActive: '#00e676',      // Verde para ícones de ação (ex: Whatsapp)
  divider: 'rgba(136, 28, 28, 0.08)'
};
class LeftDrawerNew extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      modalOpen: false,
      currentPassword: '',
      newPassword:'',
      confirmNewPassword: '',
      errorUpdatePassword: '',
      success: false,
      openForm: true,
      typeNewPassword: 'password',
      modalOpenReset: false,
      modalOpenWhatsapp: false,
      modalOpenCadastroAssociado : false,
      resetSuccess: null,
      nomeWhatsapp :'',
      codigoEmpresa : '',
      codeS4Empresa : '',
      codigoVendedor : '',
      celularsapp :'',
      openSubMenu: null, // Armazena o título ou index do menu aberto      
      imagesDocs: {
        usersTable: ''
      },
      imagesDocsUrl: {
        usersTable: ''
      },
      endereco : {
        "cep":  "",
        "tipoLogradouro":  "",
        "logradouro": "",
        "numero": "",
        "complemento": "",
        "bairro":"",
        "municipio": "",
        "uf": ""
      },      
      usersTableExt: '',
      usersTableError: '',
      razaoSocial : '',
      nomeFantasia: '',
      precoPlanos: {},
      resultadoIncluscao: null,
      isOpenMensagem : false,
      nomeVendedor: '',
      cnpj: '',
      vencimento: '',
      corte: '',
      anoMesPrimeiroPagamento: '',
      situacaoEmpresa :  '',
      currentTimeServer : '',
      statusEnvio : false


    };

    /* VERIFICAR SE É PARA EXCLUIR */
    this.styles = {
      table:{
        tableConfig:{
          ontFamily: "RubikRegular",
          textTransform: "uppercase",
        },
        theadTr:{
          fontFamily: "RubikRegular",
          textTransform: "uppercase",
        }
      },  
      floatingLabelStyle : {
        color: '#000000'
      },            
      logo: {
        fontSize: 22,
        color: '#ffffff',
        lineHeight: `${spacing.desktopKeylineIncrement}px`,
        fontWeight: 'bold',
        background: '#c10321',
        height: 56,
        textAlign: 'center',
      },
      fieldset: {
        border: '1px solid #f5aa00',
        padding: 10,
        marginTop: 15,
        paddingBottom: 25,
        borderRadius: 5
      },
      button_style: {
        border: '1px solid #e71010',
        padding: 10,
        marginTop: 15,
        paddingBottom: 5,
        borderRadius: 10
      },      
      legend: {
        width: 'auto',
        fontSize: 40,
        position: 'relative',
        marginLeft: 0,
        fontWeight: 500,
        color: '#721c24',
        padding: '0 5px'
      },    
      col: {
        marginTop: 0,
        paddingBottom: 0
      },              
      logoLink: {
        textDecoration: 'none'
      },
      iconTop:{
        paddingTop:5,
      },
      menuItem: {
        color: '#545454',
        fontSize: 14,
        fontWeight: 500,
        textTransform: 'uppercase',
        fontFamily:'RubikMedium',
        paddingLeft:15,
      },
      modal: {
        width: '45%',
        maxWidth: 'none',
      },
      updatePasswordBtn: {
        float: 'right',
        marginRight: '50px',
      },
      updateCancelBtn: {
        float: 'right',
        marginRight: '25px',
      },
      avatar: {
        div: {
          padding: '30px 0 20px 30px',
          backgroundColor: '#ffffff',
          height: 45,
          boxSizing: 'unset'
        },
        icon: {
          float: 'left',
          display: 'block',
          marginRight: 15,
          boxShadow: '0px 0px 0px 8px rgba(0,0,0,0.15)'
        },
        span: {
          backgroundColor: '#ffffff',
          fontSize: 14,
          paddingBottom: 25,
          paddingLeft: 25,
          display: 'block',
          fontWeight: 500,
          color: '#757575'
        },
        span2: {
          fontSize: 18,
          paddingTop:-10,
          textTransform: 'uppercase',
        }
      },
      sendFormSuccess: {
        padding: 10,
        color: '#155724',
        backgroundColor: '#d4edda',
        borderColor: '#c3e6cb'
      },
      sendFormError: {
        padding: 10,
        color: '#721c24',
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb'
      },
      eyePassword: {
        cursor: 'pointer',
        padding: 10,
        bottom: 0,
        top: 25,
        position: 'relative'
      },
      div_button: {
        cursor: 'pointer',
        padding: 10,
        bottom: 70,
        color: '#721c24',
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb'
      }

    };


    this.errorField = {
      currentPassword: '',
      newPassword:'',
      confirmNewPassword: ''
    };

    this.errorUpdatePassword = {
      currentPassword: '',
      newPassword:'',
      confirmNewPassword: ''
    }
    this.errorWhatSapp = {
      nome: '',
      celularWhatsapp:''
    }    
  this.openCadastroAssociado = this.openCadastroAssociado.bind(this)
  }
  componentDidMount() {
    this.state.nomeWhatsapp = '';
    this.state.celularsapp = '';
    this.getCurrentTimeServer();// Pega horário do servidor

  }
  renderMenuFromConfig() {
      // 1. Pega a string do perfil (ex: 'ADMIN')
      const userRole = localStorage.getItem('dental_y');
      
      // 2. Busca o ID string do usuário logado no localStorage
      // 💡 Altere 'user_id' para o nome exato da chave que você usa no seu sistema!
      const userId = localStorage.getItem('dental_u'); 

      const { openSubMenu } = this.state; // Pegamos o estado atual

      return menuConfig
            .filter(item => {

                // Se houver controle por usuário, ele tem prioridade
                if (item.allowedUsers) {
                    return item.allowedUsers.includes(userId);
                }

                // Senão usa o controle por perfil
                if (item.roles) {
                    return item.roles.includes(userRole);
                }

                return true;
            })
          .map((item, index) => {
              const hasSubItems = item.subItems && item.subItems.length > 0;
              const isOpen = openSubMenu === item.title;

              // Aplica a mesma regra de ID específico para filtrar também os subitens (se houver)
              const filteredSubItems = hasSubItems 
                  ? item.subItems.filter(sub => {
                      // Se existe restrição por usuário, ela tem prioridade
                      if (sub.allowedUsers) {
                      return sub.allowedUsers.includes(userId);
                      }
                      // Senão usa perfil
                      if (sub.roles) {
                      return sub.roles.includes(userRole);
                      }
                      return true;
                    })
                  : [];

              const parentContent = (
                  <div className="menu-item-content" style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                          <i className={`${item.icon} menu-icon`} 
                          style={{
                            fontSize: 16,
                            width: '30px', 
                            textAlign: 'center', marginRight: '10px'
                          }} />
                          <span>{item.title}</span>
                      </div>
                      {/* Ícone de seta para indicar que tem sub-menu */}
                      {hasSubItems && (
                          <i className={`fas ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} style={{ fontSize: '10px' }} />
                      )}
                  </div>
              );

              return (
                  <div key={index} className="menu-group-wrapper" style={{ borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
                      {/* Item Principal */}
                      {item.link && !hasSubItems ? (
                          <Link to={item.link} className="menu-anchor" onClick={() => this.props.fnOpenClose()}>
                              {parentContent}
                          </Link>
                      ) : (
                          <div 
                              className="menu-anchor" 
                              onClick={() => {
                                  if (hasSubItems) {
                                      // Alterna entre abrir e fechar o sub-menu
                                      this.setState({ openSubMenu: isOpen ? null : item.title });
                                  } else {
                                      if (item.action) this[item.action]();
                                      this.props.fnOpenClose();
                                  }
                              }}
                          >
                              {parentContent}
                          </div>
                      )}

                      {/* Subitens condicionados ao estado 'isOpen' */}
                      {hasSubItems && isOpen && (
                          <div className="sub-menu-container" style={{ backgroundColor: 'rgba(168, 36, 62, 0.05)', transition: 'all 0.3s' }}>
                              {filteredSubItems.map((sub, subIdx) => (
                                  <Link 
                                      key={`sub-${subIdx}`} 
                                      to={sub.link || '#'} 
                                      className="menu-anchor sub-item-anchor"
                                      style={{ marginLeft : 30, paddingLeft: '55px', fontSize: '12.5px' }}
                                      onClick={() => {
                                          if (sub.action) this[sub.action]();
                                          this.props.fnOpenClose();
                                      }}
                                  >
                                      <span>{sub.title}</span>
                                  </Link>
                              ))}
                          </div>
                      )}
                  </div>
              );
          });
  }
 

  checkAccentuation(text) {
    let accentuationList = "áàãâäéèêëíìîïóòõôöúùûüÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜ";

    for (let i = 0; i < text.length; i++) {
      if (accentuationList.indexOf(text[i]) >= 0) {
        return false;
      }
    }

    return true;
  }
  calculateAge(anoAniv, mesAniv, diaAniv) {
    let anoAtual = this.state.currentTimeServer.year,
        mesAtual = this.state.currentTimeServer.month,
        diaAtual = this.state.currentTimeServer.day,
        qtsAnos = anoAtual - anoAniv;

    anoAniv = +anoAniv;
    mesAniv = +mesAniv;
    diaAniv = +diaAniv;

    if (mesAtual < mesAniv || mesAtual == mesAniv && diaAtual < diaAniv)
        qtsAnos--;

    return qtsAnos < 0 ? 0 : qtsAnos;
  }
  getCurrentTimeServer() {
    // Pega a data atual do servidor
    axios.post(urlBase.loopBack + 'Sales/currentTime')
    .then((response) => {
      let state = this.state;
      state.currentTimeServer = response.data;
      this.setState(state);
    })
    .catch(function () {
      alert('Problema encontrado ao pegar data do servidor');
    });
  }
 
 converterDataParaISO  (dataInput) {
  if (dataInput === null || dataInput === undefined || dataInput === '') return null;

  let dataObj;

  // 1. Caso: O leitor já converteu para Objeto Date (Sun Sep 28 1997...)
  if (dataInput instanceof Date) {
    dataObj = dataInput;
  } 
  
  // 2. Caso: Número de série do Excel (ex: 28413)
  else if (typeof dataInput === 'number' || (!isNaN(dataInput) && typeof dataInput !== 'string')) {
    const dataExcel = Number(dataInput);
    // Ajuste: O Excel tem um bug histórico com o ano 1900. 
    // Para a maioria das datas, 25569 é o offset correto para Unix Timestamp.
    dataObj = new Date(Math.round((dataExcel - 25569) * 86400 * 1000));
    
    // Ajuste de fuso horário: Quando o Excel converte número para data, 
    // ele pode aplicar o fuso local. Vamos forçar a correção se necessário.
    const fusoHorario = dataObj.getTimezoneOffset() * 60000;
    dataObj = new Date(dataObj.getTime() + fusoHorario);
  } 
  
  // 3. Caso: String no formato DD/MM/YYYY ou D/M/YYYY
  else if (typeof dataInput === 'string' && dataInput.includes('/')) {
    const partes = dataInput.split('/');
    if (partes.length === 3) {
      const [dia, mes, ano] = partes.map(Number);
      // Criar data localmente: meses no JS começam em 0
      dataObj = new Date(ano, mes - 1, dia);
    }
  } 
  
  // 4. Caso: Outras strings de data que o JS consiga interpretar
  else {
    dataObj = new Date(dataInput);
  }

  // Validação Final
  if (!dataObj || isNaN(dataObj.getTime())) {
    console.error("Não foi possível converter:", dataInput);
    return null;
  }

  // Extração dos componentes para formatar como YYYY-MM-DD
  const diaFinal = String(dataObj.getDate()).padStart(2, '0');
  const mesFinal = String(dataObj.getMonth() + 1).padStart(2, '0');
  const anoFinal = dataObj.getFullYear();

  return `${anoFinal}-${mesFinal}-${diaFinal}`;
  
}


  gerarJSON () {
        /*
    * @type pode ser: "usersTable"
    */
        var funcionarioCadastro =  localStorage.getItem('dental_codeS4') ;
        
        if (!this.state.statusEnvio ) {
          alert("Empresa não informada");
          return;
        } else 
        if (this.state.codigoVendedor.replace(/[^0-9]/g,'') == '') {
          alert("Informe o código do vendedor");
          return 
         } else  if (document.getElementById('imagem_usersTable').value == null || document.getElementById('imagem_usersTable').value == '') {
          alert("Planilha não anexada");
        }

        if (funcionarioCadastro == "") {
            funcionarioCadastro = this.state.codigoVendedor;
        }        
        let valorPlanoTitular="";
        let valorPlanoDependente="";

        let reader = new FileReader();
        let file = document.getElementById('doc_usersTable').files[0];
        let ext = file.name.split('.').pop().toLowerCase();
        let state = this.state;
        var dataSend = {
          token: "",
          dados: {
            empresa: this.state.codeS4Empresa,
            parceiro: {
              codigo: this.state.codigoVendedor,
              maxMensalidadeId: 1,
              tipoCobranca:  1
            },
            responsavelFinanceiro: [],
            dependente:[]
          }
        };
        var listSendS4 = [];

        state.usersTableExt = ext;

        state.imagesDocs['usersTable'] = ext;

        reader.onloadend = function() {
          document.getElementById('imagem_usersTable').value = reader.result;
          // Interpretando a planilha
          if (ext == 'xlsx') {
            readXlsxFile(file).then((rows) => {
              // Planilha vazia

    
                let nomeTit = 0;
                let nomeDep = 1;
                let parentesco = 2;
                let cpf = 3;
                let cns = 4;
                let dataNasc = 5;
                //let tipoPlano = 6;
                let nomeMae = 7;
                let sexo = 8;
                let rg = 9;
                let emissaoRg = 10;
                let celular = 11;
                let email = 12;
                let codigo = 13;

              let DadosEnvioWhatsapp = [];
              let genderList = {
                'F': 0,
                'M': 1,
              }

              for (let i = 3; i < rows.length; i++) {
                // Linha com conteúdo
                 
                    if (this.state.precoPlanos != {}) {
                        let achouPlano = false
                        this.state.precoPlanos.map((currElement) => {
                          if (currElement.Id == rows[i][codigo]) {
                            valorPlanoTitular = currElement.ValorTitular;
                            valorPlanoDependente = currElement.ValorDependente;
                            achouPlano=true;
                          }
                        }); 
                        if (!achouPlano) {
                          alert("O plano "+ rows[i][codigo] + " não corresponte ao cadastrado na empresa");
                          return
                        }
                    }

                if (rows[i][nomeTit] != null || rows[i][nomeDep] != null) {
                  // Linha do titular
  
                  if (rows[i][nomeTit] != null && rows[i][nomeDep] == null) {
 
                    if (i > 3) {

                      listSendS4.push(dataSend);
                      dataSend = {
                        "token": "",
                        "dados": {
                          "empresa": this.state.codeS4Empresa,
                          "parceiro": {
                            "codigo": this.state.codigoVendedor,
                            "maxMensalidadeId": 1,
                            "tipoCobranca":  1
                          },
                          "responsavelFinanceiro": {},
                          "dependente":[]
                        }
                      };
                    }
                    

                    let _rg = '';
  
                    if  (rows[i][rg] !== null)
                        _rg = rows[i][rg].toString().replace(/[^\w\s]/gi, '');


                    dataSend.dados.responsavelFinanceiro = {
                      "codigoContrato": this.state.codeS4Empresa,
                      "nome": rows[i][nomeTit],
                      "dataNascimento": this.converterDataParaISO(rows[i][dataNasc]), 
                      "cpf": rows[i][cpf].toString().replace(/[^\w\s]/gi, ''),
                      "identidadeNumero": _rg,
                      "identidadeOrgaoExpeditor": rows[i][emissaoRg],
                      "sexo": genderList[rows[i][sexo].toUpperCase()],
                      "endereco": this.state.endereco,
                      "contatoResponsavelFinanceiro": []
                    };
  
                    if (rows[i][celular] != null) {
                      DadosEnvioWhatsapp.push ({
                        nomeMsgZap : rows[i][nomeTit],
                        numeroMsgZap : rows[i][celular].toString().replace(/[^\w\s]/gi, ''),
                        cpf :  rows[i][cpf].toString().replace(/[^\w\s]/gi, '')
                      })
                    }

                    // Add contato celular
                    if (rows[i][celular] != null) {
                      let contact = {
                        "tipo": 8,
                        "dado": rows[i][celular].toString().replace(/[^\w\s]/gi, '')
                      };
  
                      dataSend.dados.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
                    }
  
                    // Add email
        
                    if (rows[i][email] != null) {
                      let contact = {
                        "tipo": 50,
                        "dado": rows[i][email].toUpperCase()
                      };
  
                      dataSend.dados.responsavelFinanceiro.contatoResponsavelFinanceiro.push(contact);
                    }

                    let contatoDependente = [
                      { "tipo": 8, "dado": rows[i][celular].toString().replace(/[^\w\s]/gi, '') },     
                      { "tipo": 50, "dado": rows[i][email] }
                    ]; 

                    dataSend.dados.dependente.push({
                      "tipo": 1,
                      "nome": rows[i][nomeTit],
                      "dataNascimento": this.converterDataParaISO(rows[i][dataNasc]), //tempYear+'-'+tempMonth+'-'+tempDay,
                      "cpf": rows[i][cpf].toString().replace(/[^\w\s]/gi, ''),
                      "sexo": genderList[rows[i][sexo].toUpperCase()],
                      "plano": rows[i][codigo],
                      "planoValor": valorPlanoTitular,
                      "nomeMae": rows[i][nomeMae],
                      "idExtendo":  -1,
                      "funcionarioCadastro" : funcionarioCadastro,
                      "MMYYYY1Pagamento" : this.state.anoMesPrimeiroPagamento,
                      "cns": String(rows[i][cns]),
                      "contatoDependente": contatoDependente                      

                    });
                  }
                  // Linha do dependente
                  else {
                    if (rows[i][celular] != null) {
                        DadosEnvioWhatsapp.push ({
                        nomeMsgZap : rows[i][nomeDep],
                        numeroMsgZap : rows[i][celular].toString().replace(/[^\w\s]/gi, '')
                        })        
                    }          
                   
  
                    let cpfDependente = '';
                    if (rows[i][cpf] != null) {
                      cpfDependente = rows[i][cpf].toString().replace(/[^\w\s]/gi, '');
                    }

                    let contatoDependente = [
                      { "tipo": 8, "dado": rows[i][celular].toString().replace(/[^\w\s]/gi, '') },     
                      { "tipo": 50, "dado": rows[i][email] || "" }
                    ]; 

                    dataSend.dados.dependente.push({
                      "tipo": rows[i][parentesco],
                      "nome": rows[i][nomeDep],
                      "dataNascimento": this.converterDataParaISO(rows[i][dataNasc]), 
                      "cpf": cpfDependente,
                      "sexo": genderList[rows[i][sexo].toUpperCase()],
                      "plano": rows[i][codigo],
                      "planoValor": valorPlanoDependente,
                      "nomeMae": rows[i][nomeMae],
                      "idExtendo":  -1,
                      "funcionarioCadastro" : funcionarioCadastro,                     
                      "MMYYYY1Pagamento" :  this.state.anoMesPrimeiroPagamento,
                      "cns": String(rows[i][cns]),
                      "contatoDependente": contatoDependente

                    });
                    if (rows[i][celular] != null) {
                      DadosEnvioWhatsapp.push ({
                        nomeMsgZap : rows[i][nomeDep],
                        numeroMsgZap : rows[i][celular].toString().replace(/[^\w\s]/gi, ''),
                        cpf : cpfDependente
                      })
                    }                    
                  }
                }

              }
              listSendS4.push(dataSend);

              axios.post(urlBase.loopBack + 'APIS4s/NovoAssociadoPJ',  listSendS4 )
              .then((response) => {
                  let dados =  response.data;

                  if (dados != undefined ) {

                    for (let index = 0; index < dados.length; index++) {

                      if ( dados[index].codigo == 1 ) {
                        for(var x=0; x < DadosEnvioWhatsapp.length; x++) {
                            if(DadosEnvioWhatsapp[x].cpf === dados[index].cpf) {
                                let dados = {
                                  numero: DadosEnvioWhatsapp[x].numeroMsgZap,
                                  nome:  DadosEnvioWhatsapp[x].nomeMsgZap
                                };
                            
                                axios.post(urlBase.loopBack + 'Sales/enviarWhatsapp', dados)
                                  .then((result) => {
                                    console.dir(result)

                                }).catch(function (erro) {
                                    alert("Erro ao enviar mensagem: " + erro);
                                }.bind(this))

                                break;
                            } 
                        } //for(var x=0; x < DadosEnvioWhatsapp.length; x++) {
                          dados[index].mensagem = "Inclusão realizada com sucesso"
                      } // if que verifica se o codigo é um 

                    }  //for (let index = 0; index < dados.length; index++)                    

                  }

                  this.setState({resultadoIncluscao : response.data})
                
                  this.setState({isOpenMensagem: true});    

              })
              .catch(function () {
                this.setState({isOpenMensagem: false});    

              }.bind(this));  

              console.dir(listSendS4);

            });
         
          }
          else
            this.setState(state);
    
        }.bind(this);
        reader.readAsDataURL(file);



     
  }
  /** Método para tratar planilha */
  fileToBase64(typeDoc) {
    /*
    * @type pode ser: "usersTable"
    */
    if (!this.state.statusEnvio ) {
      alert("Informe a empresa antes de carregar o arquivo");
      return;
    }
    let reader = new FileReader();
    let file = document.getElementById('doc_'+typeDoc).files[0];
    let ext = file.name.split('.').pop().toLowerCase();
    let state = this.state;
    if (typeDoc == 'usersTable')
      state.usersTableExt = ext;
    else {
      if (ext == 'pdf')
        state.imagesDocs[typeDoc] = "pdf";
      else
        state.imagesDocsUrl[typeDoc] = window.URL.createObjectURL(file);
    }

    state.imagesDocs[typeDoc] = ext;

    reader.onloadend = function() {
     //document.getElementById('imagem_'+typeDoc).value = reader.result;
     document.getElementById('imagem_usersTable').value = reader.result;
      
      // Interpretando a planilha
      if (ext == 'xlsx') {
        readXlsxFile(file).then((rows) => {
          let state = this.state;
          // Planilha vazia
          if (rows.length <= 3) {
            state.imagesDocs[typeDoc] = 'error';
            state.usersTableError = 'PLANILHA VAZIA - FAVOR PREENCHER ANTES DE ENVIAR';
          }
          else {

            let nomeTit = 0;
            let nomeDep = 1;
            let parentesco = 2;
            let cpf = 3;
           // let cns = 4;
            let dataNasc = 5;
            let tipoPlano = 6;
            let nomeMae = 7;
            let sexo = 8;
           // let rg = 9;
           // let emissaoRg = 10;
            let celular = 11;
           // let email = 12;
            let codigo = 13;

            for (let i = 3; i < rows.length; i++) {

              let findPlan = false;
              if (this.state.precoPlanos != {}) {
                this.state.precoPlanos.map((currElement) => {
                  if (currElement.Id == rows[i][codigo]) {
                    findPlan = true ;
                  }
                }); 
              }
              if(!findPlan) {
                alert("Plano " + rows[i][codigo] + " informado na planilha não corresponde aos cadastrados na empresa");
                return;
              }


              if (rows[i][nomeTit] == null && rows[i][nomeDep] == null) {
                state.imagesDocs[typeDoc] = 'error';
                state.usersTableError = 'FUNCIONÁRIO SEM NOME DE TITULAR E SEM NOME DE DEPENDENTE';
                document.getElementById('doc_'+typeDoc).value = "";
                document.getElementById('imagem_'+typeDoc).value = "";
                break;
              }
              if (rows[i][tipoPlano] == null) {
                state.imagesDocs[typeDoc] = 'error';
                state.usersTableError = 'O TIPO DE PLANO É OBRIGATÓRIO PARA TITULARES E DEPENDENTES';
                document.getElementById('doc_'+typeDoc).value = "";
                document.getElementById('imagem_'+typeDoc).value = "";
                break;
              }
              else {
                let tipoPlanoList = ['clínico', 'clinico', 'orto'];
                // Não é um tipo de plano válido
                if (tipoPlanoList.indexOf(rows[i][tipoPlano].toLowerCase()) < 0) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][tipoPlano] + ' - NÃO É UM TIPO DE PLANO VÁLIDO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
              }
              if (rows[i][codigo] == null ) {
                state.imagesDocs[typeDoc] = 'error';
                state.usersTableError = 'CÓDIGO DO PLANO É OGRIGATÓRIO';
                document.getElementById('doc_'+typeDoc).value = "";
                document.getElementById('imagem_'+typeDoc).value = "";
                break;
              }
              // Linha do titular
              if (rows[i][nomeTit] != null && rows[i][nomeDep] == null) {
                // Verifica nome completo
                if (rows[i][nomeTit].indexOf('.') >= 0) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - NOME COMPLETO SEM ABREVIAÇÃO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }

                // Nome com acentuação
                if (this.checkAccentuation(rows[i][nomeTit]) == false) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - NÃO PERMITIDO ACENTUAÇÃO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Sem parentesco

                if (rows[i][parentesco] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM GRAU DE PARENTESCO INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                } else {
                  let listaCodParentesco = [1, 3, 4, 6, 8, 10 ]
                  if ( listaCodParentesco.indexOf(rows[i][parentesco]) === -1 ) {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeTit].toUpperCase()+' - CÓDIGO DO GRAU DE PARENTESCO INVÁLIDO';
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;                    
                  }
                }

                // Sem CPF
                if (rows[i][cpf] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM CPF INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Sem código 
                if (rows[i][cpf] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM CPF INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }

                // Sem data de nascimento
                if (rows[i][dataNasc] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM DATA DE NASCIMENTO INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Titular maior ou igual a 18 anos
                else {
                  let age = new Date(rows[i][dataNasc]);
                  if (this.calculateAge(age.getFullYear(), age.getMonth()+1,age.getDate()) < 18 ) {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeTit].toUpperCase()+' - DEVERÁ SER MAIOR DE IDADE (18 ANOS)';
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                  }
                }
                // Sem nome da mãe
                if (rows[i][nomeMae] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM NOME DA MÃE INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Sem sexo
                if (rows[i][sexo] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM SEXO INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                else {
                  if (rows[i][sexo].toUpperCase() != 'M' && rows[i][sexo].toUpperCase() != 'F') {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeTit].toUpperCase()+' COM SEXO INVÁLIDO. ACEITO: F/M';    
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;
                  }
                }
                // Sem celular
                if (rows[i][celular] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM CELULAR INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
              }
              // Linha dos dependentes
              else {
                // Verifica acentuação
                if (rows[i][nomeDep].indexOf('.') >= 0) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - NOME COMPLETO SEM ABREVIAÇÃO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Nome com acentuação
                if (this.checkAccentuation(rows[i][nomeDep]) == false) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - NÃO PERMITIDO ACENTUAÇÃO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }

                // Sem data de nascimento
                if (rows[i][dataNasc] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM DATA DE NASCIMENTO INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                else {
                  // Apartir de 10 anos CPF obrigatório
                  let age = new Date(rows[i][dataNasc]);
                  if (this.calculateAge(age.getFullYear(), age.getMonth()+1,age.getDate()) >= 10 && rows[i][cpf] == null) {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeDep].toUpperCase()+' - A PARTIR DE 10 ANOS CPF OBRIGATÓRIO';  
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;
                  }
                }

                if (rows[i][parentesco] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM GRAU DE PARENTESCO INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                } else {
                  let listaCodParentesco = [1, 3, 4, 6, 8, 10 ]
                  if ( listaCodParentesco.indexOf(rows[i][parentesco]) === -1 ) {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeDep].toUpperCase()+' - CÓDIGO DO GRAU DE PARENTESCO INVÁLIDO';
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;                    
                  }
                }       
         
                // Sem nome da mãe
                if (rows[i][nomeMae] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM NOME DA MÃE INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Sem sexo
                if (rows[i][sexo] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM SEXO INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                else {
                  if (rows[i][sexo].toUpperCase() != 'M' && rows[i][sexo].toUpperCase() != 'F') {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeDep].toUpperCase()+' COM SEXO INVÁLIDO. ACEITO: F ou M';    
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;
                  }
                }
              }
            }
          }

          this.setState(state);
        });
      }
      else
        this.setState(state);

    }.bind(this);
    reader.readAsDataURL(file);
  } 

  validationPassword(){
    let fields = ['currentPassword', 'newPassword', 'confirmNewPassword']
    let message = ['Campo obrigatório', 'A senha não confere'];

    for (let i = 0; i < fields.length; i++) {
      if (this.state[fields[i]] === '') {
        this.errorUpdatePassword[fields[i]] = message[0];
        this.setState(this.state);
        return false;
      }
      else
        this.errorUpdatePassword[fields[i]] = '';
    }

    if (this.state.confirmNewPassword != this.state.newPassword){
      this.errorUpdatePassword[fields[1]] = message[1];
      this.setState(this.state);
      return false
    }

    this.setState(this.state);
    return true;
  }

  updatePassword(e){
    
    e.preventDefault(e);
    let passwords = {
      oldPassword: this.state.currentPassword,
      newPassword: this.state.newPassword
    };

    if(this.validationPassword()){
      axios.post(urlBase.loopBack + 'Accounts/change-password?access_token='+localStorage.getItem('dental_t'), passwords)
      .then(() => {
          let state = this.state;
          this.state.openForm = false
          this.state.success = true;
          this.state.currentPassword = '';
          this.state.newPassword = '';
          this.state.confirmNewPassword = '';
          this.setState(state);
      }).catch(function (erro) {
        if (erro.response.data.error.code == "INVALID_PASSWORD") {
          alert('Senha atual incorreta');
        }
        else {
          alert('Erro ao alterar senha');
        }
      }.bind(this)
      );
    }
  }

  localizarVendedor () {
    this.setState({nomeVendedor : ''})

    let codeVendedor = this.state.codigoVendedor.replace(/\D/g, '');
    if (codeVendedor == null || codeVendedor == '' ) {
        alert("Informe o código do vendedor");
        return
    }

    axios.get(urlBase.loopBack + 'Salesmans?filter={"where":{"codeS4":"' + codeVendedor + '"},"include":"user"}')
    .then((result) => {
      if (result.data.length > 0 ) {
        if (result.data[0].user.active == false) 
          alert("Usuário inativo na plataforma");
        else
          this.setState({nomeVendedor : result.data[0].user.name})

      } else
      alert("Usuário com esse código não foi localizado na plataforma")
    })
    .catch(function () {
      alert('Problema encontrado ao buscar dados do vendedor  ');
    });     

  }
    
  calcularMesPrimeiroPagamento(diaCorte, dataReferencia = new Date()) {
    const mesAtual = dataReferencia.getMonth(); // 0 (Jan) a 11 (Dez)
    const anoAtual = dataReferencia.getFullYear();

    let mesPagamento = mesAtual;
    let anoPagamento = anoAtual;
    // Se o dia atual for MAIOR ou IGUAL ao dia de corte,
    // o pagamento será no MÊS SEGUINTE.
    if (diaCorte >= 10) {
      mesPagamento++; // Avança para o próximo mês

      // Verifica se o mês avançou de Dezembro (11) para Janeiro (12)
      if (mesPagamento > 11) {
        mesPagamento = 0; // Janeiro
        anoPagamento++; // Avança para o próximo ano
      }
    }

    // O mês precisa ser formatado para ter 2 dígitos (01, 02, ..., 12)
    // O mesPagamento está em base 0, então adicionamos 1 antes de formatar.
    const mesFormatado = String(mesPagamento + 1).padStart(2, '0');
    
    // O ano já está correto.
    const anoFormatado = String(anoPagamento);

    return `${anoFormatado}${mesFormatado}`;
  }

  localizarEmpresa (e) {  // apagar

    e.preventDefault(e);
    let codEmpresa = this.state.codigoEmpresa.replace(/\D/g, '');
    if (codEmpresa == null || codEmpresa == '' ) {
        alert("Informe o código da empresa");
        return
    }
    let dados = {
      codigo: codEmpresa
    };

    axios.post(urlBase.loopBack + 'APIS4s/BuscarEmpresa', dados)
      .then((response) => {

        if (response.data == null) {
          this.setState({codeS4Empresa: ''});
          this.setState({cnpj: ''});
          this.setState({nomeFantasia: ''});
          this.setState({razaoSocial: ''});
          this.setState({vencimento: ''});
          this.setState({corte: ''});
          this.setState({anoMesPrimeiroPagamento:  ''});
          this.setState({precoPlanos : {}  });
          this.setState({situacaoEmpresa : ''  });
          this.state.endereco = [];
        } else {

          this.setState({codeS4Empresa: response.data[0].Id});
          this.setState({cnpj: response.data[0].CNPJ});
          this.setState({nomeFantasia: response.data[0].NomeFantazia});
          this.setState({razaoSocial: response.data[0].RazaoSocial});
          this.setState({vencimento: response.data[0].Vencimento});
          this.setState({corte: response.data[0].Corte});
          this.setState({situacaoEmpresa : response.data[0].NomeSituacao  });
          
          let anoMesPrimeiroPagamento = this.calcularMesPrimeiroPagamento(response.data[0].Corte);

          this.setState({anoMesPrimeiroPagamento:  anoMesPrimeiroPagamento});      

          this.state.endereco = {
            "cep":  response.data[0].Cep,
            "tipoLogradouro":  response.data[0].IdTipoLogradouro,
            "logradouro": response.data[0].Logradouro,
            "numero":response.data[0]. Numero,
            "complemento": response.data[0].Complemento,
            "bairro":response.data[0].Bairro,
            "municipio": response.data[0].Municipio,
            "uf": response.data[0].Uf
          }

          var idEmpresa = response.data[0].Id;
          let dadosEmpresa = {
            IdEmpresa: idEmpresa
          };          

          axios.post(urlBase.loopBack + 'APIS4s/Planos', dadosEmpresa)
            .then((response_plano) => {
              if (response_plano.data == null) {
                this.setState({precoPlanos : {}});

              } else {
                this.setState({precoPlanos : response_plano.data  });
                this.state.statusEnvio = true;
              }
            
          }).catch(function (erro) {
            this.setState({precoPlanos : {}  });
            this.state.statusEnvio = false;

              alert("Erro ao tentar buscar planos da  empresa: " + erro);
          }.bind(this)
          );
          

        }


    }).catch(function (erro) {
      this.state.statusEnvio = false;
        alert("Erro ao tentar localizar empresa: " + erro);
    }.bind(this)
    );


  }
  enviarWhatsapp(e){ 
    
    e.preventDefault(e);
    let dados = {
      numero: this.state.celularsapp.replace(/\D/g, ''),
      nome: this.state.nomeWhatsapp
    };

    axios.post(urlBase.loopBack + 'Sales/enviarWhatsapp', dados)
      .then(() => {
        let state = this.state;
        this.state.openForm = false
        this.state.success = true;
        this.state.nomeWhatsapp = '';
        this.state.celularsapp = '';
        this.setState(state);
    }).catch(function (erro) {
        alert("Erro ao enviar mensagem: " + erro);
    }.bind(this)

    );


  }

  openUpdatePassword(){
    this.setState({modalOpen: true});
  }

  openEnviarMensagem(){   // apagar

    this.setState({modalOpenWhatsapp: true});
  }

  enviarMensagemModalClose(){
    this.setState({modalOpenWhatsapp: false});

  }
  openCadastroAssociado(){  // apagar
    this.state.statusEnvio = false;
    document.getElementById('imagem_usersTable').value = "";
    this.state.imagesDocs.usersTable = ""
    this.setState({codigoEmpresa: ''});
    this.setState({codigoVendedor: ''});
    this.setState({precoPlanos: {}});
    this.setState({nomeVendedor : ''})
    this.setState({codeS4Empresa: ''});
    this.setState({cnpj: ''});
    this.setState({nomeFantasia: ''});
    this.setState({razaoSocial: ''});
    this.setState({vencimento: ''});
    this.setState({corte: ''});
    this.setState({anoMesPrimeiroPagamento:  ''});    
    this.setState({modalOpenCadastroAssociado: true});
    this.setState({resultadoIncluscao: {}});    
    this.setState({isOpenMensagem: false});    
  }

  cadastroAssociadoClose(){ // apagar
    this.setState({modalOpenCadastroAssociado: false});
    this.setState({isOpenMensagem: false});    


  }
  handleModalClose() {
    let fields = ['currentPassword', 'newPassword', 'confirmNewPassword']

    for (let i = 0; i < fields.length; i++) {
        this.errorUpdatePassword[fields[i]] = '';
        this.setState(this.state);
    }
    this.setState({currentPassword: ''});
    this.setState({newPassword: ''});
    this.setState({confirmNewPassword: ''});
    this.setState({modalOpen: false});
    this.setState({success: false});
    this.setState({openForm: true});
  }

  handlerNestedListToggle() {
    this.setState({open: !this.state.open});
  }

  onChange(e){
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.value == '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  eyePasswordClick(type) {
    let state = this.state;
    state.typeNewPassword = type;
    this.setState(state);
  }

  resetPassword() {
    // 1. Mensagem de Confirmação
    const confirmacao = window.confirm("Tem certeza que deseja resetar sua senha? Ela será alterada para os 6 primeiros dígitos do seu CPF.");

    // Se o usuário clicar em "Cancelar", interrompe a função aqui mesmo
    if (!confirmacao) {
      return;
    }

    // 2. Início do processo de Reset
    axios.get(urlBase.loopBack + 'Salesmans?filter={"where":{"userId":"' + localStorage.getItem('dental_u') + '"}}')
      .then((response) => {
        if (response.data && response.data.length > 0) {
          let password = {
            newPassword: response.data[0].cpf.replace(/[^0-9]/g, '').substring(0, 6)
          };

          axios.post(urlBase.loopBack + 'Accounts/reset-password?access_token=' + localStorage.getItem('dental_t'), password)
            .then(() => {
              // Sucesso: Abre o modal que você personalizou antes
              this.setState({
                resetSuccess: true,
                modalOpenReset: true
              });
            })
            .catch(() => {
              // Erro no post
              this.setState({
                resetSuccess: false,
                modalOpenReset: true
              });
            });
        } else {
          alert('Vendedor não encontrado para este usuário.');
        }
      })
      .catch((error) => {
        alert('Erro ao buscar Vendedor: ' + error);
      });
  }

  resetModalClose(){
    this.setState({modalOpenReset: false});

  }
  
  render() {

    return (
      <div>
        <input id="imagem_usersTable" type="hidden"/>
        <style>{menuStyles}</style>
      <Drawer
  containerStyle={{
    background: MenuTheme.background,
    marginTop: 70, 
    boxShadow: 'none',
    overflowX: 'hidden',
    overflowY: 'auto'
  }}
  style={{
    scrollbarWidth: 'none',          // Firefox
  }}
  className="drawer-no-scroll"
  docked={true}
  open={this.props.navDrawerOpen}
>

        <div style={this.styles.avatar.div}>
          <row>
            <Avatar
              src={this.props.userimage}
              size={50}
              style={this.styles.avatar.icon}
              alt="Avatar do usuário"
            />
          </row>
        </div>

        <row>
          <p style={this.styles.avatar.span}>Bem-vindo(a), <br/>
            <span style={this.styles.avatar.span2}>{this.props.username}</span><br />
            <span style={{fontSize:'10px'}}>Versão: {urlBase.version}</span>            
          </p>          
        </row>
        {/** Montagem de Menu automático */}
        <div style={{ backgroundColor: MenuTheme.background, minHeight: 'calc(100vh - 200px)' }}>          
            {/* Removemos o <List> e usamos uma div comum */}
            <div className="menu-container">

                {this.renderMenuFromConfig()}
                
                <Divider style={{ backgroundColor: MenuTheme.divider, margin: '10px 0' }} />
            </div>
        </div>
         {/** Fim Novo */}   
                 
        {/* DIALOG*/}
        {/* ALTERAR SENHA*/}
        
        <Dialog
          title={
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              padding: '10px 0' 
            }}>
              <i className="fas fa-lock" style={{ color: '#666', fontSize: '24px', marginBottom: '10px' }}></i>
              <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#333' }}>Alterar Senha</span>
              <hr style={{ width: '80%', border: '0', borderTop: '1px solid #eee', marginTop: '15px' }} />
            </div>
          }
          titleStyle={{ padding: '20px 0 0' }}
          bodyStyle={{ padding: '20px 40px' }} // Aumentado o respiro lateral
          modal={false}
          open={this.state.modalOpen}
          onRequestClose={this.handleModalClose.bind(this)}
          contentStyle={{ ...this.styles.modal, width: '450px', maxWidth: '90%' }} // Largura controlada
        >
          <div>
            {/* Mensagem de Sucesso - Estilo "Alert" */}
            {this.state.success && (
              <div style={{
                backgroundColor: '#e8f5e9',
                color: '#2e7d32',
                padding: '15px',
                borderRadius: '4px',
                textAlign: 'center',
                marginBottom: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <i className="fas fa-check-circle" style={{ fontSize: '30px', marginBottom: '10px' }}></i>
                <p style={{ margin: 0, fontWeight: '500' }}>Senha alterada com sucesso!</p>
                <RaisedButton
                  label="Fechar"
                  style={{ marginTop: '15px' }}
                  onClick={this.handleModalClose.bind(this)}
                />
              </div>
            )}

            {this.state.openForm && (
              <form onSubmit={this.updatePassword.bind(this)} style={{ marginTop: '10px' }}>
                <Grid container spacing={16}>
                  <Grid item xs={12}>
                    <TextField
                      errorText={this.errorUpdatePassword.currentPassword}
                      floatingLabelText="Senha Atual"
                      type="password"
                      name="currentPassword"
                      value={this.state.currentPassword}
                      onChange={this.onChange.bind(this)}
                      fullWidth={true}
                    />
                  </Grid>

                  <Grid item xs={12} style={{ position: 'relative', display: 'flex', alignItems: 'flex-end' }}>
                    <div style={{ flex: 1 }}>
                      <TextField
                        errorText={this.errorUpdatePassword.newPassword}
                        floatingLabelText="Nova Senha"
                        type={this.state.typeNewPassword}
                        name="newPassword"
                        value={this.state.newPassword}
                        onChange={this.onChange.bind(this)}
                        fullWidth={true}
                      />
                    </div>
                    {/* Ícone do olho posicionado de forma mais elegante */}
                    <div style={{ paddingBottom: '12px', marginLeft: '10px' }}>
                      <i
                        style={{ cursor: 'pointer', color: '#999', fontSize: '18px' }}
                        className={this.state.typeNewPassword === "password" ? "far fa-eye" : "far fa-eye-slash"}
                        onClick={this.eyePasswordClick.bind(this, this.state.typeNewPassword === "password" ? 'text' : 'password')}
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      errorText={this.errorUpdatePassword.confirmNewPassword}
                      floatingLabelText="Confirmar Nova Senha"
                      type="password"
                      name="confirmNewPassword"
                      value={this.state.confirmNewPassword}
                      onChange={this.onChange.bind(this)}
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>

                <div style={{ 
                  marginTop: '30px', 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  gap: '10px',
                  paddingBottom: '20px' 
                }}>
                  <Button
                    onClick={this.handleModalClose.bind(this)}
                    style={{ ...Styles.buttonCancel, textTransform: 'none' }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={this.updatePassword.bind(this)}
                    variant="contained"
                    style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                  >
                    Salvar Senha
                  </Button>
                </div>
              </form>
            )}
          </div>
        </Dialog>
        {/* RESETAR SENHA*/}
        <Dialog
          title={
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              padding: '10px 0' 
            }}>
              {/* Ícone dinâmico: Chave se for reset, Alerta se for erro */}
              <i 
                className={this.state.resetSuccess ? "fas fa-key" : "fas fa-exclamation-triangle"} 
                style={{ 
                  color: this.state.resetSuccess ? '#4CAF50' : '#F44336', 
                  fontSize: '28px', 
                  marginBottom: '10px' 
                }}
              ></i>
              <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#333' }}>
                Resetar Senha
              </span>
              <hr style={{ width: '80%', border: '0', borderTop: '1px solid #eee', marginTop: '15px' }} />
            </div>
          }
          titleStyle={{ padding: '20px 0 0' }}
          bodyStyle={{ padding: '20px 40px' }}
          modal={false}
          open={this.state.modalOpenReset}
          onRequestClose={this.resetModalClose.bind(this)}
          contentStyle={{ ...this.styles.modal, width: '450px', maxWidth: '90%' }}
        >
          <div style={{ textAlign: 'center' }}>
            {this.state.resetSuccess !== null && (
              <div>
                {this.state.resetSuccess === true ? (
                  /* Cenário de SUCESSO */
                  <div style={{
                    backgroundColor: '#e8f5e9',
                    color: '#2e7d32',
                    padding: '20px',
                    borderRadius: '8px',
                    border: '1px solid #c8e6c9'
                  }}>
                    <p style={{ margin: '0 0 10px 0', fontSize: '16px', fontWeight: '500' }}>
                      Senha resetada com sucesso!
                    </p>
                    <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5', opacity: 0.9 }}>
                      Sua nova senha são os <strong>6 (seis) primeiros números do seu CPF</strong>.
                    </p>
                  </div>
                ) : (
                  /* Cenário de ERRO */
                  <div style={{
                    backgroundColor: '#ffebee',
                    color: '#c62828',
                    padding: '20px',
                    borderRadius: '8px',
                    border: '1px solid #ffcdd2'
                  }}>
                    <p style={{ margin: 0, fontSize: '16px', fontWeight: '500' }}>
                      Erro ao tentar resetar a senha.
                    </p>
                    <p style={{ margin: '5px 0 0 0', fontSize: '13px' }}>
                      Por favor, tente novamente ou contate o suporte.
                    </p>
                  </div>
                )}

                {/* Botão de Fechar Unificado */}
                <div style={{ marginTop: '25px', display: 'flex', justifyContent: 'center' }}>
                  <Button
                    label="Entendido"
                    onClick={this.resetModalClose.bind(this)}
                    variant="contained"
                    style={{ 
                      backgroundColor: this.state.resetSuccess ? '#4CAF50' : '#666',
                      color: '#fff',
                      textTransform: 'none',
                      fontWeight: 'bold',
                      padding: '0 30px'
                    }}
                  >
                    Fechar
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Dialog>
        {/* ENVIO DE WHATSAPP*/}
        <Dialog
          title={
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              padding: '10px 0' 
            }}>
              {/* Ícone do WhatsApp com a cor característica */}
              <i className="fab fa-whatsapp" style={{ color: '#25D366', fontSize: '32px', marginBottom: '10px' }}></i>
              <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#333' }}>Enviar WhatsApp</span>
              <hr style={{ width: '80%', border: '0', borderTop: '1px solid #eee', marginTop: '15px' }} />
            </div>
          }
          titleStyle={{ padding: '20px 0 0' }}
          bodyStyle={{ padding: '20px 40px' }}
          modal={false}
          open={this.state.modalOpenWhatsapp}
          onRequestClose={this.handleModalClose.bind(this)}
          contentStyle={{ ...this.styles.modal, width: '450px', maxWidth: '90%' }}
        >
          <div>
            {/* Feedback de Sucesso */}
            {this.state.success && (
              <div style={{
                backgroundColor: '#e8f5e9',
                color: '#2e7d32',
                padding: '20px',
                borderRadius: '8px',
                textAlign: 'center',
                marginBottom: '20px',
                border: '1px solid #c8e6c9'
              }}>
                <i className="fas fa-paper-plane" style={{ fontSize: '24px', marginBottom: '10px' }}></i>
                <p style={{ margin: 0, fontWeight: '500' }}>Mensagem enviada com sucesso!</p>
                <RaisedButton
                  label="Fechar"
                  style={{ marginTop: '15px' }}
                  onClick={this.handleModalClose.bind(this)}
                />
              </div>
            )}

            {this.state.openForm && (
              <form onSubmit={this.enviarWhatsapp.bind(this)} style={{ marginTop: '10px' }}>
                <Grid container spacing={16}>
                  {/* Campo Nome */}
                  <Grid item xs={12}>
                    <TextField
                      errorText={this.errorWhatSapp.nome}
                      floatingLabelText="Nome do Destinatário"
                      type="text"
                      name="nomeWhatsapp"
                      value={this.state.nomeWhatsapp}
                      onChange={this.onChange.bind(this)}
                      fullWidth={true}
                      leftIcon={<i className="fas fa-user" style={{ color: '#999', marginRight: '10px' }} />}
                    />
                  </Grid>

                  {/* Campo Celular com Máscara */}
                  <Grid item xs={12}>
                    <TextField
                      errorText={this.errorWhatSapp.celularWhatsapp}
                      floatingLabelText="Celular / WhatsApp"
                      fullWidth={true}
                      underlineShow={true} // Reativado para manter o padrão visual dos inputs
                    >
                      <InputMask
                        mask="(99) 9 9999-9999"
                        maskChar=" "
                        type="tel"
                        name="celularsapp"
                        value={this.state.celularsapp}
                        onChange={this.onChange.bind(this)}
                        style={{
                          width: '100%',
                          border: 'none',
                          outline: 'none',
                          fontSize: '16px',
                          padding: '8px 0',
                          marginTop: '16px',
                          backgroundColor: 'transparent'
                        }}
                      />
                    </TextField>
                  </Grid>
                </Grid>

                {/* Botões de Ação */}
                <div style={{ 
                  marginTop: '40px', 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  gap: '12px',
                  paddingBottom: '10px' 
                }}>
                  <Button
                    onClick={this.enviarMensagemModalClose.bind(this)}
                    style={{ ...Styles.buttonCancel, textTransform: 'none' }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={this.enviarWhatsapp.bind(this)}
                    variant="contained"
                    style={{ 
                      ...Styles.buttonSuccess, 
                      backgroundColor: '#25D366', // Forçando a cor do WhatsApp no botão
                      color: '#FFF',
                      textTransform: 'none', 
                      fontWeight: 'bold',
                      padding: '0 25px'
                    }}
                  >
                    <i className="fab fa-whatsapp" style={{ marginRight: '8px' }}></i>
                    Enviar Mensagem
                  </Button>
                </div>
              </form>
            )}
          </div>
        </Dialog>
        
        {/* CADASTRO DE ASSOCIADO (APAGAR QUANDO VALIDAR NOVA TELA) */} 
        <Dialog
              title={
                <div>
                  Cadastrar Associado
                </div>
              }
              titleStyle={{textAlign:'center'}}
              bodyStyle={{padding: '0px 10px 88px'}}
              modal={false}
              open={this.state.modalOpenCadastroAssociado}
              onRequestClose={this.handleModalClose.bind(this)}
              autoScrollBodyContent={true}
              contentStyle={this.styles.modal}
            >
            <div>
              {/* Mensagem de retorno do formulário */
                this.state.isOpenMensagem  ? 
                (/* Formulário salvo com sucesso */
                <Grid container spacing={6} style={{marginTop:10}}>
                  <Grid  item xs={12} sm={12} md={12} lg={12}>
                    <div style={{textAlign: 'center', marginLeft: '30'}}>

                    <table id="table_id"  >
                        <thead >
                          <tr  >
                          <th  style={{fontSize: 10,width:'100' }}>CPF</th>
                            <th  style={{fontSize: 10,width:'100', textAlign: 'center' }}>Código</th>
                            <th  style={{fontSize: 10,width:'500' }}>Mensagem </th>

                          </tr>
                        </thead>

                        <tbody>
                        {/* */}
                        { 
                         this.state.isOpenMensagem ? 
                          this.state.resultadoIncluscao.map((item) =>
                          <tr
                          >
                            <td style={{fontSize: 11 }}>{item.cpf}</td>
                            <td style={{fontSize: 11 }}>{item.codigo}</td>
                            <td style={{fontSize: 11 }}>{item.mensagem}</td>
                                                                                         
                          </tr>
                          ) : ('')
                        } 
                          
                        </tbody>
                                                          
                    </table>  
                    </div>
                  </Grid>
                  <Grid style={{ textAlign: 'right', marginTop:40, marginLeft: '200'}} item xs={12} sm={12} md={12} lg={4}>
                            <Button
                            className="button_plans"
                            onClick={this.cadastroAssociadoClose.bind(this)}
                            type="submit"
                          >
                            Fechar
                          </Button>                     

                  </Grid>
                </Grid>
                ) : (
              <div>
                    MOdal OPen :        {this.state.modalOpenCadastroAssociado}

                {
                this.state.openForm == true ? (
                  <form onSubmit={this.updatePassword.bind(this)}>
                    <Grid container spacing={10}>
                            <Grid item xs={10} sm={10} md={10} lg={4}>
                              <TextField
                                className="input_style"
                                hintText="Código Vendedor (S4e)"
                               // floatingLabelText="Códido Vendedor (S4e)"
                                type="text"
                                name="codigoVendedor"
                                value={this.state.codigoVendedor}
                                onChange={this.onChange.bind(this)}
                                />
                                
                            </Grid>
                            <Grid item xs={10} sm={10} md={10} lg={4}>
                                <div   style={{ width:'100%', textAlign:"center", marginTop:"20", color: 'rgb(139, 6, 6)', cursor:'pointer'}} >
                                  <Link  onClick={this.localizarVendedor.bind(this)}  >
                                    <p style={{fontSize: 15 }} className="fa fa-search fa-3x" > Vendedor </p>
                                  </Link> 
                                </div>
                            </Grid>                              
                    </Grid>
                    <Grid item xs={10} sm={10} md={10} lg={10}>
                        <p  style={{fontSize: 12, color: 'rgb(139, 6, 6)'}}> {' '+this.state.nomeVendedor}</p>                                              
                    </Grid>                      
                    <Grid container>
                        <Grid item xs={10} sm={10} md={10} lg={4}>
                          <TextField
                            className="input_style"
                            hintText="Códido da Empresa (S4e)"
                            //floatingLabelText="Código da Empresa (S4e)"
                            type="text"
                            name="codigoEmpresa"
                            value={this.state.codigoEmpresa}
                            onChange={this.onChange.bind(this)}
                            fullWidth={true} />                   
                            
                        </Grid>
                        <Grid item xs={10} sm={10} md={10} lg={4}>
                          <div   style={{ width:'100%', textAlign:"center", marginTop:"20", color: 'rgb(139, 6, 6)', cursor:'pointer'}} >
                            <Link  onClick={this.localizarEmpresa.bind(this)}  >
                              <p style={{fontSize: 15 }} className="fa fa-search fa-1x" > Empresa</p>
                            </Link> 
                          </div>
                        </Grid>
                    </Grid>
                  
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Grid container spacing={10}>
                                                     
                        {/* EMPRESA */}
                        <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>

                              <fieldset style={this.styles.fieldset}>
                              <Grid container spacing={12}>
                                    {/* DADOS DA EMPRESA*/}                       
                                    <Grid item xs={10} sm={10} md={10} lg={6}>
                                        <div style={{width:'100%', textAlign:"left"}}>
                                            <label  style={{cursor:'pointer'}}>
                                              {
                                                this.state.cnpj == "" || this.state.precoPlanos == {} ?  (''):
                                                (
                                                  <div>
                                                      <p style={{fontSize: 15, color: 'rgb(100, 123, 234)'}}>
                                                        Empresa 
                                                      </p>
                                                        <div>
                                                            <p style={{fontSize: 12, color: 'rgb(1, 1, 1)'}}>
                                                            <b style={{fontSize: 10, color: 'rgb(231, 16, 16)'}}>CNPJ :</b>  {' '+this.state.cnpj}<br/>
                                                            <b style={{fontSize: 10, color: 'rgb(231, 16, 16)'}}> Razão Social</b> :{' '+this.state.razaoSocial}<br/>
                                                            <b style={{fontSize: 10, color: 'rgb(231, 16, 16)'}}>Nome Fantasia</b> : {' '+this.state.nomeFantasia}<br/>
                                                            <b style={{fontSize: 10, color: 'rgb(231, 16, 16)'}}>Corte</b> : {' '+this.state.corte}<br/>
                                                            <b style={{fontSize: 10, color: 'rgb(231, 16, 16)'}}>Mês primeiro pagamento</b> : {' '+ this.state.anoMesPrimeiroPagamento.substring(4,6) + "/" +this.state.anoMesPrimeiroPagamento.substring(0,4)}<br/>

                                                            <b style={{fontSize: 10, color: '#e71010'}}> Situação </b>: {' '+this.state.situacaoEmpresa}  
                                                          </p>
                                            
                                                        </div>   
                                                      <div>                                                   
                                                    </div>  
                                                                                              
                                                  </div>
            
                                                                                
                                              )}
                                            </label>

                                        </div>                            
                                    </Grid>
                                    {/* TABELA DE PLANOS */}                       
                                    <Grid item xs={10} sm={10} md={10} lg={6}>
                                    {
                                      this.state.precoPlanos.length == undefined  ? (''):
                                        ([
                                    <p style={{fontSize: 15, color: 'rgb(100, 123, 234)'}}>
                                        Planos 
                                    </p>,

                                    <table id="table_id"  >
                                          <thead >
                                            <tr  >
                                              <th  style={{fontSize: 10,width:'50' }}>Cód.</th>
                                              <th  style={{fontSize: 10,width:'150', paddingRight:'10' }}>Plano</th>
                                              <th  style={{fontSize: 10,width:'80' }}>Titular</th>
                                              <th  style={{fontSize: 10,width:'70' }}>Dep</th>
                                              <th  style={{fontSize: 10,width:'70' }}>Agreg.</th>

                                            </tr>
                                          </thead>

                                          <tbody>
                                            { 
                                            this.state.precoPlanos.map((item) =>
                                            <tr
                                            >
                                              <td style={{fontSize: 10 }}>{item.Id}</td>
                                              <td style={{fontSize: 10 }}>{item.Nome}</td>
                                              <td style={{fontSize: 10 }}>{item.ValorTitular.toLocaleString('pt-br', {minimumFractionDigits: 2})}</td>
                                              <td style={{fontSize: 10 }}>{item.ValorDependente.toLocaleString('pt-br', {minimumFractionDigits: 2})}</td>
                                              <td style={{fontSize: 10 }}>{item.ValorAgregado.toLocaleString('pt-br', {minimumFractionDigits: 2})}</td>                                                                                            
                                            </tr>
                                            )}
                                          </tbody>
                                                          
                                    </table>   
                                    ])}
                                                     
                                    </Grid>                          
                              </Grid> 
                              </fieldset>    
                        </Grid>      



                        {/* ANEXOS*/}                       
                        <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={12}>
                              <div style={{width:'100%', textAlign:"center"}}>
                                  <label htmlFor="doc_usersTable" style={{cursor:'pointer'}}>
                                    <p style={{fontSize: 15, textAlign: 'center'}} className="label_doc_style">PLANILHA COM RELAÇÃO DE USUÁRIOS</p>
                                    {
                                      this.state.imagesDocs.usersTable == "" ? (
                                    <div>
                                      <div id="name_file_choose_usersTable" className="doc_style">ESCOLHER O ARQUIVO</div>
                                      <p id="legend_doc_style_usersTable" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                                    </div>
                                    ):(
                                      this.state.imagesDocs.usersTable == "xlsx" ? (
                                    <div>
                                      <i id="name_file_pdf_usersTable" className="far fa-file-excel fa-3x icon_layout">{""}</i>
                                      <p style={{fontSize: 12, color: 'rgb(100, 123, 234)'}}>
                                        ANEXADO COM SUCESSO!
                                      </p>
                                    </div>
                                      ):(
                                        this.state.imagesDocs.usersTable == "error" ? (
                                    <div>
                                      <div id="name_file_choose_usersTable" className="doc_style">ESCOLHER O ARQUIVO</div>
                                      <p id="i_error_plan" style={{fontSize: 12, color: '#ed4134'}}>{this.state.usersTableError}</p>
                                    </div>
                                        ) : (
                                    <div>
                                      <div id="name_file_choose_usersTable" className="doc_style">ESCOLHER O ARQUIVO</div>
                                      <p style={{fontSize: 12, color: '#ed4134'}}>
                                      ERRO - FORMATO ACEITO: .XLSX
                                      </p>
                                    </div>
                                        )
                                      )
                                    )}
                                  </label>
                                  <input id="doc_usersTable" style={{visibility:"hidden",position:'absolute',left: -9999}}
                                    type="file" name="usersTable" onChange={this.fileToBase64.bind(this, 'usersTable')}

                                  />
                              </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* BOTÕES*/}                       
                    <Grid container spacing={8} style={{ marginTop: 10 }}>
                        <Grid item  style={{ textAlign: 'right' }} xs={12} sm={4} md={5} lg={5}>
                            <Button
                            className="button_plans"
                            onClick={this.gerarJSON.bind(this)}
                            type="submit"
                          >
                            Enviar
                          </Button>  
 
                        </Grid>
                        <Grid item style={{ textAlign: 'right' }} xs={12} sm={4} md={6} lg={5}>
                        <Button
                            className="button_plans"
                            onClick={this.cadastroAssociadoClose.bind(this)} 
                            type="submit"
                          >
                            Cancelar
                          </Button>                           

                            
                        </Grid>
                    </Grid>
                    </form>
                  ) : ('')
              }
              </div>
              )}
            </div>
        </Dialog>               
      </Drawer>    
      </div>
    );
  }

}

LeftDrawerNew.propTypes = {
  navDrawerOpen: PropTypes.bool,
  username: PropTypes.string,
  userimage: PropTypes.string,
  fnOpenClose: PropTypes.func,
};

export default LeftDrawerNew;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/LeftDrawerNew.js
 **/